module.exports = __webpack_public_path__ + "img/MikeVarney.a1f67a05.jpg";